module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Stardust.554e5ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Stardust.jpg
// module id = cPCl
// module chunks = 0